<template>
  <div class="home" id="">
		<div class="pale-bg px-3 px-md-5">
			<Nav></Nav>
			<Hero></Hero>
		</div>
  </div>
</template>

<script>
// @ is an alias to /src

import Nav from "../components/Nav";
import Hero from "../components/Hero";

export default {
  components: {
		Nav,
		Hero
  }
};
</script>
